import SubLanding from "@/components/SubLanding";
export default function SenecaAI() { return <SubLanding slug="seneca-ai" />; }
